var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArch = function SvgArch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 286,
    viewBox: "0 -2 141 284"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.957 49.82c49.349 0 89.35 40 89.35 89.349s-40.001 89.35-89.35 89.35v49.831c76.864 0 139.169-62.316 139.169-139.181C140.126 62.305 77.821 0 .957 0z"
  })));
};
export default SvgArch;